import { filter, includes, isEmpty } from 'lodash-es';
import { UserDto } from '../models/dto';

/**
 * @deprecated since "Community Profiles" feature is implemented
 */

export const SWITCHING_USERS = {
	Salar: '5c35e1e8-a065-4bf4-8ff6-97e46e365a95',
	MandiZhou: '0caebe41-a051-4031-a823-fbc12af69e83',
	MariaVargas: '0af6cef9-f15f-4d5d-90fb-83c27f912757',
	ScottEarl: 'f8e7e26c-d511-402a-a74d-6aa7b3b57aab',
	LeoMartinez: 'e1f42c31-a294-4057-ac44-8a94b94f141e',
	KatieWinters: 'eb8a0d22-c840-498f-83f4-a2979d1dbd60',
	PriscillaPope: '5d04c111-4df2-4f1b-8668-85e26701e7f4',
	BlairGallacher: '2551a9cf-b46f-43bd-8cec-db97cbbc3096',
	JamesQuigley: '95cf66d4-e1fe-48de-adfe-3dc538f340ae',
	EllieRome: 'ee001dc4-e25d-4f62-8bc8-3831a6a1dfe7',
	ZacSagay: 'cbf00535-ae22-4162-81fb-c59e028f41b6',
	PhilipMiller: 'cb5bb6db-c484-40fd-9173-1a2b7261643f',
	ChloeDunn: '19755512-858f-4416-b88e-6a6361386513',
	ATXVibeTribe: 'adb81f65-5058-410b-b6ec-ea61de4dda67',
	PhillipThomson: 'ff484304-4853-4447-86fc-a0324ff2912f',
	SamathaMartinez: 'f8699850-6a98-4fc9-86d9-e3930ce82cea',
	TeresaKrammer: '03958dc3-71f0-4012-bc87-4b0c4329bec0',
	TeresaKrammer2: '7fbb9240-9e38-4868-95ba-e045fc30ce9e',
	VanessaMitchell: '83aee428-a64c-4532-9b42-d3c07d4ca4e7',
	JessieWussow: 'c93d2f6f-f64b-42d2-b744-e64e07346f3b',
	JamiePratt: '6bc2a69a-8e09-4603-b21b-aa426f64f652',
	DanielleGertner: 'bc3c7fb7-0091-4d1d-800d-662824878064',
	KyraFrances: '07b28ef0-3098-4f74-87bc-d66d9ce36020',
	JKFoley: '7f5d4443-c1dd-4fd8-8195-7373ec32684b',
	TalynLeJeune: 'aefb0cb4-b83b-4f5f-9dc7-74a2bbb468e3',
	AdamHorn: '9c6f04e5-9301-4576-bb16-d074b00bfe59',
	DerekLively: 'a7c7d497-d560-44c4-b7a2-d77ff3f15c36',
	RachelWimberley: '162636f0-40cb-4ec6-b8b9-6dc696c9f941',
	JamieKidd: 'f5268d94-9af2-44da-bfdd-b0811a3ddfb8',
	Outliers: 'cf79fc68-5adb-41ba-815e-d65d5222e4db',
	AlexanderGouyet: '6a1a4e03-cecd-4f69-bd3a-b1b0bc04323d',
	Wendall: '2673daba-f6ef-44bb-9789-918ea7b2e7ab',
	Braydon: '2a5ddf24-1844-4b02-9ea6-f4b4b566a789',
	JoeLucky: 'd081a243-e00d-40e4-b04e-166b43a8d8bc',
	ChristieCurtis: 'f41deaf3-8c6c-468c-bfd3-c7b1aa5c2b77',
	PaigeBockhorn: 'db80d01f-ea03-463b-b51c-c883e0de480a',
	MeganSwinford: '8c4390a7-c3b3-4552-a605-edba5672f196',
	JadeTeetsel: '9b301d75-0ee1-488c-ad09-ecea220ea785',
	MelLloyd: '5e8e998a-9fba-4807-b2d8-2b74e64ebddb',
	Adriana: '1d48435f-3b1c-428d-97e7-612a1fcc5cab',
	NewAccount: 'd08592e7-5d9e-471a-bb78-05e28226f702',
	MichaelBishop: 'fb493e28-619e-4fa1-94e8-bda98d3b0f54',
	EmilyOrr: '3bbaac1a-5f7e-4c7a-a4ef-7e7ce591948e',
	AmberS: '725a0754-224e-4b90-bb15-081a53deb71a',
	AnisaGillfillan: '033bc45c-109e-4966-9bf4-53508ee7e2cd',
	AnnaHsu: '11ef6500-a308-414d-a611-7eda51bb8f0b',
	QiResource: '6c144e60-70e3-49a2-b8e4-59eba1ce3806',
	DelaneyBeam: 'ccf804e4-685c-4758-9054-050dcdca7ba3',
	ErinHickok: 'cde08bbc-5dbd-47c8-a3c1-e490bf82bdd4',
	EsteMarie: '13a1ebbc-a40c-4d7b-bdc8-9bbbf85643d5',
	KevinBaugh: 'e1f98024-df1e-44d9-964b-a8e1f101fd4f',
	KirkBarnett: '3b3952b9-b675-467c-9e7d-42afb787051d',
	KristenGaither: 'a25b7ae8-81c8-4987-988b-a73bc206395a',
	LaReynaHernandez: '092984cb-d4fe-4cdb-8429-117456c9921c',
	LauraJoy711: 'd3869b55-2120-4b34-9422-d134038ecb46',
	MaddieBrennan: '947ef107-7ab6-4c47-b274-5c8810a9ebe1',
	MaryaSalman: '0af6970b-9aaf-4cbb-9617-05487c9339cc',
	Whalen: 'cf5cfa56-dd05-40ed-80ea-9866eda8cd59',
	PaulGarza: '2372953a-42a7-4133-9c94-432c70320686',
	RachelRosen: '69fb1451-7b2a-410f-bcc7-cf9fb532732f',
	RohiniMauk: '5cfdc75e-86aa-4d1d-af0a-3f80d68caee5',
	ScarlettTramper: '1ce9010c-92b2-434f-8df6-a67b254104ac',
	Stevenecker: 'fc9c15e0-4a54-4a9f-8063-2243e151f8ea',
	Tseng: '2673daba-f6ef-44bb-9789-918ea7b2e7ab',
	Melissa: '872b8feb-7911-48b5-9c34-edfbcd02a1f0',
	Heidi: '6cb279a4-76bd-4a29-beeb-52b67bd8dbc5',
	MadelineScales: 'a1f5fdd2-43fd-4282-a255-2ad164a49103',
	JoelSchopp: 'bb2f555e-9ee5-483d-8870-6aca9317b834',
	// Businesses:
	SweatPals: '1655ef0d-c378-4be8-aa0a-262aa67f2e85',
	NovemberProject: 'bdfad61b-e00a-4313-a921-6b1e3eb16b17',
	NoMeatAthlete: '33f0b726-9d41-49db-97c2-a85f941acfce',
	TheMorningJos: 'ad922ba9-b1e8-4b16-a112-9d70ffbf88f1',
	YogaEastAustin: 'e008f5e1-1a28-4d15-b3f3-fdeb1b1239b3',
	SunriseTrackClub: 'd324053c-8a5a-4ff0-867d-b155571a2ff5',
	RawRunning: '1cb1b02e-cc82-4d18-a3c3-ecf430e80bc3',
	WaterlooGreenway: '16e12e94-9a80-41d6-a097-9fe42391a390',
	ComedorRunClub: '3a3e54a1-a742-4554-81cd-d6ce07a8bab2',
	WimHofGroup: '9e6355eb-e512-4f75-bf43-5d18c701aea0',
	YTXAustin: 'dcab3a7e-7c07-4066-9836-847c80543644',
	SprintSquad: '2ae33da0-16e5-4cca-8aa0-62403046eaa5',
	AustinBeerRun: '7145e6ba-6a71-4ff4-b7ee-2e018cf938ca',
	TheLoopRunClub: 'ebab815b-0c53-4d57-b07f-6195890ff00b',
	FireAndIce: '0bda2cb6-262f-4aa6-b0d5-09763ee0a52c',
	ArtistRunClub: 'c21dacb2-3fbd-4b12-8747-d06532296651',
	MotivationalDaily: '47ea1da0-a37b-491f-ba50-f19f70a01995',
	SummerYogaClubATX: '66cb5f9c-1617-455c-93a4-3b776af044c6',
	UltimateFrisbeeATX: '20fd30b2-fc6a-4eda-8aaf-a206c72bae37',
	BreakfastClubAustin: '14f12eed-8969-4daa-ad60-753624f62184',
	SunriseSwimClub: 'f9cb107c-ceb6-460a-81e3-b042bd5615b2',
	PpZhou: '9c43d2f5-672f-4873-92e9-4eea46d7a624',
	AustinBoulderingProject: 'c43e1da7-8048-4453-ac70-926d28f4591b',
	LinaTremblay: 'bddd795e-62e8-48e6-9f9a-91580a5418c0',
	AdamWalsh: '65939336-5d90-4d2f-86e9-7dbf2ada007f',
	VioletCrownCyclingClub: 'aeda1dcc-2391-4510-8a2f-c25044f75dec',
	AustinBoulderingClub: '7c04a417-cbac-4b8a-851d-c41b185204ef',
	BlackSwanYoga: 'c9f94750-a6e7-4d16-8028-6b80c93c0d29',
	FiveRunTwo: 'fa8bc7c8-cc40-413a-adbd-f4526fcce4e4',
	RideBikesAustin: 'fb188fe3-108f-4d02-865a-e23cebadee9e',
	RiseAndRunSouthAustin: '75b60143-b871-45cc-b83c-be33e283d6d3',
	FleetFeet: '2acf850a-a4b5-4dca-8dae-24891cc4f30d',
	F45: 'a6258628-aded-4609-8464-dd579a1fb603',
	SportsbrarunATX: '392a4e65-350e-4d77-8d3d-2aa8b5d4af97',
	OutliersRunClubATX: '028ce20d-8f03-4a0e-a08c-29bfc2467cfe',
	WarriorWomenATX: 'fbb970c0-1657-4960-aa34-477e9d361ca5',
	CampGladiator: 'e457f754-a1da-4c87-9cf8-d03916992fec',
	MoreMindfulYoga: 'af616a7a-b9fb-41a7-9634-32580597fe83',
	Insid3out: '3d0021a7-209a-4681-bec2-4d656303de08',
	SquatchFrontierFitness: '756c6189-9c51-4ba1-952c-1c532333bc67',
	AustinRunnersClub: '072f6161-ccd0-4201-8501-d76dcd2390a7',
	LuckysMindGarden: '56212f1c-55f3-40a4-8d99-04493ce48872',
	SwiftFit: 'aa0d28ad-8ce7-44b9-9c15-d52a6ad3212e',
	ATXMovementCollective: '7747ede8-1233-42a6-a093-ca2da823b957',
	Fitcidence: 'ad6dd510-418e-43c9-ba66-a5098003f19a',
	HotGirlWalkingClub: '9e498b9d-9a45-46b6-a9e1-a160138592a3',
	AustinTennisClub: '9489d5b9-c0e1-49ab-b92e-f83a590b37fc',
	SweatPalsVolleyball: 'f99e185b-a796-49c4-bbce-1e34ee29e383',
	AcroYogaAustin: '6a46a9e5-46cb-4200-a3a7-06f2c7acc1fa',
};

export const SWITCHING_USERS_LISTS = {
	[SWITCHING_USERS.Salar]: [
		SWITCHING_USERS.SweatPals,
		SWITCHING_USERS.NovemberProject,
		SWITCHING_USERS.NoMeatAthlete,
		SWITCHING_USERS.TheMorningJos,
		SWITCHING_USERS.YogaEastAustin,
		SWITCHING_USERS.SunriseTrackClub,
		SWITCHING_USERS.RawRunning,
		SWITCHING_USERS.WaterlooGreenway,
		SWITCHING_USERS.ComedorRunClub,
		SWITCHING_USERS.WimHofGroup,
		SWITCHING_USERS.YTXAustin,
		SWITCHING_USERS.SprintSquad,
		SWITCHING_USERS.AustinBeerRun,
		SWITCHING_USERS.TheLoopRunClub,
		SWITCHING_USERS.FireAndIce,
		SWITCHING_USERS.ArtistRunClub,
		SWITCHING_USERS.MotivationalDaily,
		SWITCHING_USERS.SummerYogaClubATX,
		SWITCHING_USERS.UltimateFrisbeeATX,
		SWITCHING_USERS.BreakfastClubAustin,
		SWITCHING_USERS.SunriseSwimClub,
		SWITCHING_USERS.PpZhou,
		SWITCHING_USERS.AustinBoulderingProject,
		SWITCHING_USERS.LinaTremblay,
		SWITCHING_USERS.AdamWalsh,
		SWITCHING_USERS.FiveRunTwo,
		SWITCHING_USERS.RideBikesAustin,
		SWITCHING_USERS.RiseAndRunSouthAustin,
		SWITCHING_USERS.FleetFeet,
		SWITCHING_USERS.F45,
		SWITCHING_USERS.ATXVibeTribe,
		SWITCHING_USERS.SportsbrarunATX,
		SWITCHING_USERS.OutliersRunClubATX,
	],
	[SWITCHING_USERS.MandiZhou]: [
		SWITCHING_USERS.SweatPals,
		SWITCHING_USERS.PpZhou,
		SWITCHING_USERS.VioletCrownCyclingClub,
		SWITCHING_USERS.AustinBoulderingClub,
		SWITCHING_USERS.BlackSwanYoga,
		SWITCHING_USERS.SportsbrarunATX,
		SWITCHING_USERS.ChloeDunn,
		SWITCHING_USERS.PhilipMiller,
		SWITCHING_USERS.WarriorWomenATX,
		SWITCHING_USERS.SweatPalsVolleyball,
	],
	[SWITCHING_USERS.MariaVargas]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.ScottEarl]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.LeoMartinez]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.KatieWinters]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.PriscillaPope]: [SWITCHING_USERS.SweatPals],
	[SWITCHING_USERS.BlairGallacher]: [SWITCHING_USERS.ComedorRunClub],
	[SWITCHING_USERS.JamesQuigley]: [SWITCHING_USERS.ATXVibeTribe],
	[SWITCHING_USERS.EllieRome]: [SWITCHING_USERS.WimHofGroup],
	[SWITCHING_USERS.ZacSagay]: [SWITCHING_USERS.SprintSquad],
	[SWITCHING_USERS.PhilipMiller]: [SWITCHING_USERS.MandiZhou],
	[SWITCHING_USERS.ChloeDunn]: [SWITCHING_USERS.MandiZhou],
	[SWITCHING_USERS.PhillipThomson]: [SWITCHING_USERS.FiveRunTwo],
	[SWITCHING_USERS.SamathaMartinez]: [SWITCHING_USERS.F45],
	[SWITCHING_USERS.TeresaKrammer]: [SWITCHING_USERS.SportsbrarunATX],
	[SWITCHING_USERS.TeresaKrammer2]: [SWITCHING_USERS.SportsbrarunATX],
	[SWITCHING_USERS.VanessaMitchell]: [SWITCHING_USERS.SportsbrarunATX],
	[SWITCHING_USERS.JessieWussow]: [SWITCHING_USERS.SportsbrarunATX],
	[SWITCHING_USERS.JamiePratt]: [SWITCHING_USERS.FiveRunTwo],
	[SWITCHING_USERS.DanielleGertner]: [SWITCHING_USERS.WarriorWomenATX],
	[SWITCHING_USERS.KyraFrances]: [SWITCHING_USERS.WarriorWomenATX],
	[SWITCHING_USERS.JKFoley]: [SWITCHING_USERS.WarriorWomenATX],
	[SWITCHING_USERS.TalynLeJeune]: [SWITCHING_USERS.CampGladiator],
	[SWITCHING_USERS.AdamHorn]: [SWITCHING_USERS.MoreMindfulYoga],
	[SWITCHING_USERS.DerekLively]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.AlexanderGouyet]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.Wendall]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.RachelWimberley]: [SWITCHING_USERS.TheMorningJos],
	[SWITCHING_USERS.JamieKidd]: [SWITCHING_USERS.WarriorWomenATX],
	[SWITCHING_USERS.Outliers]: [SWITCHING_USERS.OutliersRunClubATX],
	[SWITCHING_USERS.Braydon]: [SWITCHING_USERS.SquatchFrontierFitness],
	[SWITCHING_USERS.JoeLucky]: [SWITCHING_USERS.SquatchFrontierFitness, SWITCHING_USERS.LuckysMindGarden],
	[SWITCHING_USERS.ChristieCurtis]: [SWITCHING_USERS.AustinRunnersClub],
	[SWITCHING_USERS.PaigeBockhorn]: [SWITCHING_USERS.NoMeatAthlete],
	[SWITCHING_USERS.MeganSwinford]: [SWITCHING_USERS.SwiftFit],
	[SWITCHING_USERS.JadeTeetsel]: [SWITCHING_USERS.ATXMovementCollective],
	[SWITCHING_USERS.MelLloyd]: [SWITCHING_USERS.ATXMovementCollective],
	[SWITCHING_USERS.Adriana]: [SWITCHING_USERS.RiseAndRunSouthAustin],
	[SWITCHING_USERS.NewAccount]: [SWITCHING_USERS.Fitcidence],
	[SWITCHING_USERS.MichaelBishop]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.EmilyOrr]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.AmberS]: [SWITCHING_USERS.NovemberProject],
	[SWITCHING_USERS.AnisaGillfillan]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.AnnaHsu]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.QiResource]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.DelaneyBeam]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.ErinHickok]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.EsteMarie]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.KevinBaugh]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.KristenGaither]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.LaReynaHernandez]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.LauraJoy711]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.MaddieBrennan]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.MaryaSalman]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.Whalen]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.PaulGarza]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.RachelRosen]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.RohiniMauk]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.ScarlettTramper]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.Stevenecker]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.Tseng]: [SWITCHING_USERS.Insid3out],
	[SWITCHING_USERS.Melissa]: [SWITCHING_USERS.RiseAndRunSouthAustin],
	[SWITCHING_USERS.Heidi]: [SWITCHING_USERS.HotGirlWalkingClub],
	[SWITCHING_USERS.MadelineScales]: [SWITCHING_USERS.HotGirlWalkingClub],
	[SWITCHING_USERS.PriscillaPope]: [SWITCHING_USERS.AustinTennisClub],
	[SWITCHING_USERS.JoelSchopp]: [SWITCHING_USERS.AcroYogaAustin],
};

export const getHardcodedSwitchingUsers = (userId: string, prevUserId: string | undefined) => {
	const forCurrentUsersArr = userId ? SWITCHING_USERS_LISTS[userId] || [] : [];

	const forPrevUsersArr = prevUserId ? SWITCHING_USERS_LISTS[prevUserId] || [] : [];

	if (prevUserId && isEmpty(forCurrentUsersArr) && !isEmpty(forPrevUsersArr)) {
		return [prevUserId];
	}

	return forCurrentUsersArr;
};

interface FilterHardcodedUsersBadgesParams {
	userId: string;
	switchingUsers: UserDto[];
}

export const filterHardcodedUsersBadges = ({ userId, switchingUsers }: FilterHardcodedUsersBadgesParams) => {
	// leave only SweatPals badge
	if (includes([SWITCHING_USERS.Salar, SWITCHING_USERS.MandiZhou], userId)) {
		return filter(switchingUsers, { id: SWITCHING_USERS.SweatPals });
	}

	// without leader badges
	if (includes([SWITCHING_USERS.PhilipMiller, SWITCHING_USERS.ChloeDunn, SWITCHING_USERS.ATXVibeTribe], userId)) {
		return [];
	}

	// leave all
	return switchingUsers;
};
